<template>
    <div>
        <el-radio-group v-if="rule.id==0" v-model="radio1" class="tab">
            <el-radio-button label="单加"></el-radio-button>
            <el-radio-button label="批量添加"></el-radio-button>
        </el-radio-group>
        <el-form v-show="radio1=='单加'" :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="100px">
            <el-form-item label="手机号码" prop="mobile">
                <el-input placeholder="请输手机号码" v-model="rule.mobile" clearable></el-input>
            </el-form-item>
            <el-form-item label="CCID" prop="ccid">
                <el-input placeholder="请输入CCID" v-model="rule.ccid" clearable></el-input>
            </el-form-item>
            <el-form-item label="IMSI" prop="imsi">
                <el-input placeholder="请输入IMSI" v-model="rule.imsi" clearable></el-input>
            </el-form-item>
            <el-form-item label="运营商" prop="operatorId">
                <el-select v-model="rule.operatorId">
                    <el-option value="" label="请选择运营商"></el-option>
                    <el-option v-for="x in yunyingshang" :key="x.id" :value="x.id" :label="x.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商" prop="supplierId">
                <el-select v-model="rule.supplierId">
                    <el-option value="" label="请选择供应商"></el-option>
                    <el-option v-for="x in gongyingshang" :key="x.id" :value="x.id" :label="x.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
        <el-form v-show="radio1=='批量添加'" :model="rule2" :rules="rules2" ref="forms2" class="demo-ruleForm" label-width="100px">
            <el-form-item label="设备列表" prop="file">
                <input type="file" name="file" @change="getFile($event)">
            </el-form-item>
            <el-form-item label="运营商" prop="operatorId">
                <el-select v-model="rule2.operatorId">
                    <el-option value="" label="请选择运营商"></el-option>
                    <el-option v-for="x in yunyingshang" :key="x.id" :value="x.id" :label="x.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商" prop="supplierId">
                <el-select v-model="rule2.supplierId">
                    <el-option value="" label="请选择供应商"></el-option>
                    <el-option v-for="x in gongyingshang" :key="x.id" :value="x.id" :label="x.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit2">提交</el-button>
                <el-button @click="block">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            var validPhone = (rule,value,callback) => {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            }
            return {
                name: 'edit',
                radio1:'单加',
                rule: {
                    id:0,
                    ccid:'',
                    imsi:'',
                    mobile:'',
                    operatorId:'',
                    supplierId:'',
                },
                rules: {
                    ccid: { required: true, message: '请输入CCID' },
                    imsi: { required: true, message: '请输入IMSI' },
                    mobile: [
                        { required: true, message: '请输入手机号' },
                        {validator: validPhone,trigger:'blur'}
                    ],
                    operatorId: { required: true, message: '请输入运营商' },
                    supplierId: { required: true, message: '请输入供应商' },
                },
                yunyingshang:[],
                gongyingshang:[],
                rule2: {
                    id:0,
                    file: [],
                    operatorId:'',
                    supplierId:'',
                },
                rules2: {
                    file: { required: true, message: '请上传文件' },
                    operatorId: { required: true, message: '请输入运营商' },
                    supplierId: { required: true, message: '请输入供应商' },
                },
            }
        },
        created() {
            this.$http.get('/manage/operator/listAll').then(results => {
                this.yunyingshang = results['data']['data'];
            });
            this.$http.get('/manage/supplier/listAll').then(results => {
                this.gongyingshang = results['data']['data'];
            });
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/sim/card');
                }else {
                    this.rule = this.$store.state.editInfo;
                    this.rule.operatorId = this.$store.state.editInfo.operate.id;
                    this.rule.supplierId = this.$store.state.editInfo.supplier.id;
                }
            }
        },
        methods: {
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        if(this.rule.id == 0) {
                            this.$http.post('/manage/sim/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/card/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            delete this.rule.operate;
                            delete this.rule.supplier;
                            this.$http.post('/manage/sim/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/card/index');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            submit2() {
                this.$refs['forms2'].validate(valid => {
                    if(valid) {
                        let headers = {
                            'Content-Type': 'multipart/form-data'
                        };
                        let formData = new FormData();
                        formData.append('file',this.rule2.file);
                        formData.append('operatorId',this.rule2.operatorId);
                        formData.append('supplierId',this.rule2.supplierId);
                        this.$http.post('/manage/sim/addByExcel',formData,{headers:headers}).then(rs => {
                            if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/sim/card/index');
                                }else {
                                    this.rule2.file = '';
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                        })
                    }
                });
            },
            getFile(event){
                var file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    //    上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        var ext = imgName.substr(idx+1).toUpperCase();   
                        ext = ext.toLowerCase(); 
                        this.rule2.file = file[i];
                    }
                }
            },
            block() {
                this.$router.push('/sim/card/index');
            }
        }
    }
</script>
<style scoped>
.tab{margin-bottom: 20px; margin-left: 100px;}
</style>